import get from 'lodash/get'

export const getUniversalMenuIsOpen = (state) => state.universalMenu.open
export const getUniversalMenuAccountMenuIsOpen = (state) => state.universalMenu.accountMenuOpen
export const getSelectedUniversalMenuCategory = (state) => state.universalMenu.category
export const getSelectedUniversalMenuSelectedTab = (state) => state.universalMenu.selectedTab
export const getUniversalMenuApiUrls = (state) => get(state, ['content', 'global', 'universal_menu', 'api']);
export const getUniversalMenuHeader = (state) => get(state, ['content', 'global', 'universal_menu', 'header']);
export const getUniversalMenuAccountMenu = (state) => get(state, ['content', 'global', 'universal_menu', 'account_menu']);
export const getUniversalMenuFooter = (state) => get(state, ['content', 'global', 'universal_menu', 'footer']);
export const getUniversalMobileMenuIsOpen = (state) => state.universalMenu.mobileMenuOpen



// WEBPACK FOOTER //
// ./src/selectors/universal-menu.js